export const CLIENT_VERSION_HEADER_KEY = 'voltage-client-version';
export const VOLTAGE_CLIENT_VERSION = '3.4.1';

export const DOLLAR_VALUE_OF_VOLUNTEER_HOUR: Record<number, number> = {
    2025: 36.14, // Value reported in April 2026 based on 2025 data
    2024: 34.79, // Value reported in April 2025 based on 2024 data
    2023: 33.49, // Value reported in April 2024 based on 2023 data
    2022: 31.80, // Value reported in April 2023 based on 2022 data
    2021: 29.95, // Value reported in April 2022 based on 2021 data
    2020: 28.54, // Value reported in April 2021 based on 2020 data
    2019: 27.20, 
    2018: 25.43,
    2017: 24.69,
    2016: 24.14,
    2015: 23.56,
    2014: 23.07,
    2013: 22.55,
    2012: 22.14,
    2011: 21.79,
    2010: 21.36,
    2009: 20.85 
}

export const LATEST_DOLLAR_VALUE_OF_VOLUNTEER_HOUR = DOLLAR_VALUE_OF_VOLUNTEER_HOUR[Math.max(...(Object.keys(DOLLAR_VALUE_OF_VOLUNTEER_HOUR).map(Number)))];